import React, { Component } from 'react';
import favicon from './logo2.png'

class Navbar extends Component {
    render() {
        return (
            <nav className="navbar navbar-expand-sm navbar-light fixed-top" style={{ "backgroundColor": "#ffffff", "fontSize": "12pt" }}>
                <a className="navbar-brand" href="#home"><img src={favicon} className="d-inline-block align-top" height="85px;" alt="Btown Logo" /><div className="appTitle">{this.props.view}</div></a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" id="toggleButton">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item">
                            <a className="nav-link" href="http://www.ashaweb.org">HOME</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="http://www.ashaweb.org/about/">ABOUT</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href=" http://www.ashaweb.org/resources/">RESOURCES</a>
                        </li>


                        <li className="nav-item">
                            <a className="nav-link" href="http://www.ashaweb.org/news-events/">EVENTS</a>
                        </li>


                        <li className="nav-item">
                            <a className="nav-link" href="http://www.ashaweb.org/news-events/advocacy/">ADVOCACY</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" href="http://www.ashaweb.org/network/">#NETWORK</a>
                        </li>

                        <li className="nav-item">
                            <a className="nav-link" href="http://www.ashaweb.org/join/">JOIN</a>
                        </li>

                    </ul>
                </div>
            </nav>
        )
    }
}

export default Navbar;